export default Object.freeze({
    0x00: {mnemonic: 'RETURN', args: 0, end: true},
    0x01: {mnemonic: 'RETURNR', args: 1, end: true},
    0x02: {mnemonic: 'CALL', args: 1, end: true},
    0x03: {mnemonic: 'CALL_R', args: 5, end: true},
    0x04: {mnemonic: 'CALL_T', args: 1, end: true},
    0x05: {mnemonic: 'CALL_GR', args: 6, end: true},
    0x06: {mnemonic: 'JUMP', args: 1, end: true},
    0x07: {mnemonic: 'JUMPIF', args: 2, end: true},
    0x08: {mnemonic: 'SWITCH_V2', args: 3, end: true},
    0x09: {mnemonic: 'SWITCH_V3', args: 4, end: true},
    0x0a: {mnemonic: 'SWITCH_VN', args: 2, end: true},
    0x0b: {mnemonic: 'CALL_VALUE', args: 1, end: false},
    0x0c: {mnemonic: 'PUSH', args: 1, end: false},
    0x0d: {mnemonic: 'DUPA', args: 0, end: false},
    0x0e: {mnemonic: 'DUP', args: 1, end: false},
    0x0f: {mnemonic: 'POP', args: 1, end: false},
    0x10: {mnemonic: 'INCA', args: 0, end: false},
    0x11: {mnemonic: 'INC', args: 1, end: false},
    0x12: {mnemonic: 'DECA', args: 0, end: false},
    0x13: {mnemonic: 'DEC', args: 1, end: false},
    0x14: {mnemonic: 'ADD', args: 3, end: false},
    0x15: {mnemonic: 'SUB', args: 3, end: false},
    0x16: {mnemonic: 'MUL', args: 3, end: false},
    0x17: {mnemonic: 'DIV', args: 3, end: false},
    0x18: {mnemonic: 'MOD', args: 3, end: false},
    0x19: {mnemonic: 'POW', args: 3, end: false},
    0x1a: {mnemonic: 'STORE', args: 2, end: false},
    0x1b: {mnemonic: 'SHA3', args: 2, end: false},
    0x1c: {mnemonic: 'SHA256', args: 2, end: false},
    0x1d: {mnemonic: 'BLAKE2B', args: 2, end: false},
    0x1e: {mnemonic: 'LT', args: 3, end: false},
    0x1f: {mnemonic: 'GT', args: 3, end: false},
    0x20: {mnemonic: 'EQ', args: 3, end: false},
    0x21: {mnemonic: 'ELT', args: 3, end: false},
    0x22: {mnemonic: 'EGT', args: 3, end: false},
    0x23: {mnemonic: 'NEQ', args: 3, end: false},
    0x24: {mnemonic: 'AND', args: 3, end: false},
    0x25: {mnemonic: 'OR', args: 3, end: false},
    0x26: {mnemonic: 'NOT', args: 2, end: false},
    0x27: {mnemonic: 'TUPLE', args: 2, end: false},
    0x28: {mnemonic: 'ELEMENT', args: 3, end: false},
    0x29: {mnemonic: 'SETELEMENT', args: 4, end: false},
    0x2a: {mnemonic: 'MAP_EMPTY', args: 1, end: false},
    0x2b: {mnemonic: 'MAP_LOOKUP', args: 3, end: false},
    0x2c: {mnemonic: 'MAP_LOOKUPD', args: 4, end: false},
    0x2d: {mnemonic: 'MAP_UPDATE', args: 4, end: false},
    0x2e: {mnemonic: 'MAP_DELETE', args: 3, end: false},
    0x2f: {mnemonic: 'MAP_MEMBER', args: 3, end: false},
    0x30: {mnemonic: 'MAP_FROM_LIST', args: 2, end: false},
    0x31: {mnemonic: 'MAP_SIZE', args: 2, end: false},
    0x32: {mnemonic: 'MAP_TO_LIST', args: 2, end: false},
    0x33: {mnemonic: 'IS_NIL', args: 2, end: false},
    0x34: {mnemonic: 'CONS', args: 3, end: false},
    0x35: {mnemonic: 'HD', args: 2, end: false},
    0x36: {mnemonic: 'TL', args: 2, end: false},
    0x37: {mnemonic: 'LENGTH', args: 2, end: false},
    0x38: {mnemonic: 'NIL', args: 1, end: false},
    0x39: {mnemonic: 'APPEND', args: 3, end: false},
    0x3a: {mnemonic: 'STR_JOIN', args: 3, end: false},
    0x3b: {mnemonic: 'INT_TO_STR', args: 2, end: false},
    0x3c: {mnemonic: 'ADDR_TO_STR', args: 2, end: false},
    0x3d: {mnemonic: 'STR_REVERSE', args: 2, end: false},
    0x3e: {mnemonic: 'STR_LENGTH', args: 2, end: false},
    0x3f: {mnemonic: 'BYTES_TO_INT', args: 2, end: false},
    0x40: {mnemonic: 'BYTES_TO_STR', args: 2, end: false},
    0x41: {mnemonic: 'BYTES_CONCAT', args: 3, end: false},
    0x42: {mnemonic: 'BYTES_SPLIT', args: 3, end: false},
    0x43: {mnemonic: 'INT_TO_ADDR', args: 2, end: false},
    0x44: {mnemonic: 'VARIANT', args: 4, end: false},
    0x45: {mnemonic: 'VARIANT_TEST', args: 3, end: false},
    0x46: {mnemonic: 'VARIANT_ELEMENT', args: 3, end: false},
    0x47: {mnemonic: 'BITS_NONEA', args: 0, end: false},
    0x48: {mnemonic: 'BITS_NONE', args: 1, end: false},
    0x49: {mnemonic: 'BITS_ALLA', args: 0, end: false},
    0x4a: {mnemonic: 'BITS_ALL', args: 1, end: false},
    0x4b: {mnemonic: 'BITS_ALL_N', args: 2, end: false},
    0x4c: {mnemonic: 'BITS_SET', args: 3, end: false},
    0x4d: {mnemonic: 'BITS_CLEAR', args: 3, end: false},
    0x4e: {mnemonic: 'BITS_TEST', args: 3, end: false},
    0x4f: {mnemonic: 'BITS_SUM', args: 2, end: false},
    0x50: {mnemonic: 'BITS_OR', args: 3, end: false},
    0x51: {mnemonic: 'BITS_AND', args: 3, end: false},
    0x52: {mnemonic: 'BITS_DIFF', args: 3, end: false},
    0x53: {mnemonic: 'BALANCE', args: 1, end: false},
    0x54: {mnemonic: 'ORIGIN', args: 1, end: false},
    0x55: {mnemonic: 'CALLER', args: 1, end: false},
    0x56: {mnemonic: 'BLOCKHASH', args: 2, end: false},
    0x57: {mnemonic: 'BENEFICIARY', args: 1, end: false},
    0x58: {mnemonic: 'TIMESTAMP', args: 1, end: false},
    0x59: {mnemonic: 'GENERATION', args: 1, end: false},
    0x5a: {mnemonic: 'MICROBLOCK', args: 1, end: false},
    0x5b: {mnemonic: 'DIFFICULTY', args: 1, end: false},
    0x5c: {mnemonic: 'GASLIMIT', args: 1, end: false},
    0x5d: {mnemonic: 'GAS', args: 1, end: false},
    0x5e: {mnemonic: 'ADDRESS', args: 1, end: false},
    0x5f: {mnemonic: 'GASPRICE', args: 1, end: false},
    0x60: {mnemonic: 'LOG0', args: 1, end: false},
    0x61: {mnemonic: 'LOG1', args: 2, end: false},
    0x62: {mnemonic: 'LOG2', args: 3, end: false},
    0x63: {mnemonic: 'LOG3', args: 4, end: false},
    0x64: {mnemonic: 'LOG4', args: 5, end: false},
    0x65: {mnemonic: 'SPEND', args: 2, end: false},
    0x66: {mnemonic: 'ORACLE_REGISTER', args: 7, end: false},
    0x67: {mnemonic: 'ORACLE_QUERY', args: 8, end: false},
    0x68: {mnemonic: 'ORACLE_RESPOND', args: 6, end: false},
    0x69: {mnemonic: 'ORACLE_EXTEND', args: 3, end: false},
    0x6a: {mnemonic: 'ORACLE_GET_ANSWER', args: 5, end: false},
    0x6b: {mnemonic: 'ORACLE_GET_QUESTION', args: 5, end: false},
    0x6c: {mnemonic: 'ORACLE_QUERY_FEE', args: 2, end: false},
    0x6d: {mnemonic: 'AENS_RESOLVE', args: 4, end: false},
    0x6e: {mnemonic: 'AENS_PRECLAIM', args: 3, end: false},
    0x6f: {mnemonic: 'AENS_CLAIM', args: 5, end: false},
    0x70: {mnemonic: 'AENS_UPDATE', args: 6, end: false},
    0x71: {mnemonic: 'AENS_TRANSFER', args: 4, end: false},
    0x72: {mnemonic: 'AENS_REVOKE', args: 3, end: false},
    0x73: {mnemonic: 'BALANCE_OTHER', args: 2, end: false},
    0x74: {mnemonic: 'VERIFY_SIG', args: 4, end: false},
    0x75: {mnemonic: 'VERIFY_SIG_SECP256K1', args: 4, end: false},
    0x76: {mnemonic: 'CONTRACT_TO_ADDRESS', args: 2, end: false},
    0x77: {mnemonic: 'AUTH_TX_HASH', args: 1, end: false},
    0x78: {mnemonic: 'ORACLE_CHECK', args: 4, end: false},
    0x79: {mnemonic: 'ORACLE_CHECK_QUERY', args: 5, end: false},
    0x7a: {mnemonic: 'IS_ORACLE', args: 2, end: false},
    0x7b: {mnemonic: 'IS_CONTRACT', args: 2, end: false},
    0x7c: {mnemonic: 'IS_PAYABLE', args: 2, end: false},
    0x7d: {mnemonic: 'CREATOR', args: 1, end: false},
    0x7e: {mnemonic: 'ECVERIFY_SECP256K1', args: 4, end: false},
    0x7f: {mnemonic: 'ECRECOVER_SECP256K1', args: 3, end: false},
    0x80: {mnemonic: 'ADDRESS_TO_CONTRACT', args: 2, end: false},
    0x81: {mnemonic: 'BLS12_381_G1_NEG', args: 2, end: false},
    0x82: {mnemonic: 'BLS12_381_G1_NORM', args: 2, end: false},
    0x83: {mnemonic: 'BLS12_381_G1_VALID', args: 2, end: false},
    0x84: {mnemonic: 'BLS12_381_G1_IS_ZERO', args: 2, end: false},
    0x85: {mnemonic: 'BLS12_381_G1_ADD', args: 3, end: false},
    0x86: {mnemonic: 'BLS12_381_G1_MUL', args: 3, end: false},
    0x87: {mnemonic: 'BLS12_381_G2_NEG', args: 2, end: false},
    0x88: {mnemonic: 'BLS12_381_G2_NORM', args: 2, end: false},
    0x89: {mnemonic: 'BLS12_381_G2_VALID', args: 2, end: false},
    0x8a: {mnemonic: 'BLS12_381_G2_IS_ZERO', args: 2, end: false},
    0x8b: {mnemonic: 'BLS12_381_G2_ADD', args: 3, end: false},
    0x8c: {mnemonic: 'BLS12_381_G2_MUL', args: 3, end: false},
    0x8d: {mnemonic: 'BLS12_381_GT_INV', args: 2, end: false},
    0x8e: {mnemonic: 'BLS12_381_GT_ADD', args: 3, end: false},
    0x8f: {mnemonic: 'BLS12_381_GT_MUL', args: 3, end: false},
    0x90: {mnemonic: 'BLS12_381_GT_POW', args: 3, end: false},
    0x91: {mnemonic: 'BLS12_381_GT_IS_ONE', args: 2, end: false},
    0x92: {mnemonic: 'BLS12_381_PAIRING', args: 3, end: false},
    0x93: {mnemonic: 'BLS12_381_MILLER_LOOP', args: 3, end: false},
    0x94: {mnemonic: 'BLS12_381_FINAL_EXP', args: 2, end: false},
    0x95: {mnemonic: 'BLS12_381_INT_TO_FR', args: 2, end: false},
    0x96: {mnemonic: 'BLS12_381_INT_TO_FP', args: 2, end: false},
    0x97: {mnemonic: 'BLS12_381_FR_TO_INT', args: 2, end: false},
    0x98: {mnemonic: 'BLS12_381_FP_TO_INT', args: 2, end: false},
    0x99: {mnemonic: 'AENS_LOOKUP', args: 2, end: false},
    0x9a: {mnemonic: 'ORACLE_EXPIRY', args: 2, end: false},
    0x9b: {mnemonic: 'AUTH_TX', args: 1, end: false},
    0x9c: {mnemonic: 'STR_TO_LIST', args: 2, end: false},
    0x9d: {mnemonic: 'STR_FROM_LIST', args: 2, end: false},
    0x9e: {mnemonic: 'STR_TO_UPPER', args: 2, end: false},
    0x9f: {mnemonic: 'STR_TO_LOWER', args: 2, end: false},
    0xa0: {mnemonic: 'CHAR_TO_INT', args: 2, end: false},
    0xa1: {mnemonic: 'CHAR_FROM_INT', args: 2, end: false},
    0xa2: {mnemonic: 'CALL_PGR', args: 7, end: true},
    0xa3: {mnemonic: 'CREATE', args: 3, end: true},
    0xa4: {mnemonic: 'CLONE', args: 4, end: true},
    0xa5: {mnemonic: 'CLONE_G', args: 5, end: true},
    0xa6: {mnemonic: 'BYTECODE_HASH', args: 2, end: false},
    0xa7: {mnemonic: 'FEE', args: 1, end: false},
    0xa8: {mnemonic: 'ADDRESS_TO_BYTES', args: 2, end: false},
    0xa9: {mnemonic: 'POSEIDON', args: 3, end: false},
    0xaa: {mnemonic: 'MULMOD', args: 4, end: false},
    0xab: {mnemonic: 'BAND', args: 3, end: false},
    0xac: {mnemonic: 'BOR', args: 3, end: false},
    0xad: {mnemonic: 'BXOR', args: 3, end: false},
    0xae: {mnemonic: 'BNOT', args: 2, end: false},
    0xaf: {mnemonic: 'BSL', args: 3, end: false},
    0xb0: {mnemonic: 'BSR', args: 3, end: false},
    0xfa: {mnemonic: 'DEACTIVATE', args: 0, end: false},
    0xfb: {mnemonic: 'ABORT', args: 1, end: true},
    0xfc: {mnemonic: 'EXIT', args: 1, end: true},
    0xfd: {mnemonic: 'NOP', args: 0, end: false},
    0xfe: {mnemonic: 'FUNCTION', args: 0, end: false},
    0xff: {mnemonic: 'EXTEND', args: 0, end: false},
})
